import { useState } from "react";

import ScrollToRootOnLoad from "./ScrollToRootOnLoad";
import Order from "./Order";
import Review from "./Review";
import Receipt from "./Receipt";

const App = ({ brand }) => {
	const [started, setStarted] = useState(0);
	const [submitted, setSubmitted] = useState(0);

	const handleStarted = (status) => {
		setStarted(status);
	};

	const handleSubmitted = (id) => {
		setSubmitted(id);
	};

	return (
		<>
			{started && submitted ? (
				<>
					<ScrollToRootOnLoad />
					<Receipt started={handleStarted} id={submitted} />
				</>
			) : started ? (
				<>
					<ScrollToRootOnLoad />
					<Review
						started={handleStarted}
						submitted={handleSubmitted}
						brand={brand}
					/>
				</>
			) : (
				<Order started={handleStarted} brand={brand} />
			)}
		</>
	);
};

export default App;
